import CustomerDetailPage from './detail/CustomerDetailPage.vue';
import CustomerListPage from './list/CustomerListPage.vue';

const routes = [
  {
    path: '/customers',
    name: 'customers',
    component: CustomerListPage,
    meta: {
      title: 'Clients',
      requiresAuth: true
    }
  },
  {
    path: '/customer/detail',
    name: 'customerDetail',
    component: CustomerDetailPage,
    meta: {
      title: 'Transaction',
      requiresAuth: true
    }
  }
];

export default routes;
